import {PrivateCommand} from "../PrivateCommand";
import cmp from "../../../context/context";

export class GetAcceptanceLevelPrivateCommand extends PrivateCommand {
    /* STATIC */

    /* INSTANCE */
    public override execute(option?: string, callback?: Function) {
        callback?.(cmp().acceptanceLevel());
    }
}
